import React from "react";
import PostHeader from "./PostHeader";
import ReactionBar from "./ReactionBar";
import S3Image from "./S3Image";
import { ANNOUNCEMENT_BADGE_CLASS, hasImage } from "./constants";

const AnnouncementCard = ({ post, onReacted }) => (
  <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
    <PostHeader
      post={post}
      badgeClass={ANNOUNCEMENT_BADGE_CLASS}
      badgeLabel="Announcement"
    />

    <div className="px-4 pb-1 pt-3">
      {post.title && (
        <p className="mb-1.5 text-[15px] font-semibold text-gray-800">
          {post.title}
        </p>
      )}

      {post.body && (
        <p className="mb-3 whitespace-pre-wrap text-sm leading-relaxed text-gray-600">
          {post.body}
        </p>
      )}

      {hasImage(post.image) && (
        <div className="mb-3">
          <S3Image image={post.image} alt={post.title} />
        </div>
      )}
    </div>

    <ReactionBar post={post} onReacted={onReacted} />
  </div>
);

export default AnnouncementCard;
